module.exports = __webpack_public_path__ + "img/cathedral.ef45dd4c.jpg";